import styles from './styles.module.css';
import inputStyles from '../../InputLabel/Input.module.css';
import { Countries, GraphTypes, SelectionLevel } from '../../../types/general';
import DeleteButton from '../../DeleteButton';
import SelectionLayoutRow from '../SelectionLayoutRow/SelectionLayoutRow';
import { useEffect, useState } from 'react';
import { useDiagramStore } from '../../../store/useDiagramStore';
import Input from '../../Input/Input';
import { Icon } from '../../index';
import { Icons } from '../../Icon/Icon';

interface SelectionRowCompactProps {
    type: SelectionLevel;
    country: string;
    value: string;
    assetAllocation: number;
    handleDelete: any;
    validateAssetAllocationChange: any;
    onClick: any;
    isAllocationChangeable?: boolean;
}

const SelectionRowCompact = ({
    type,
    country,
    value,
    assetAllocation,
    handleDelete,
    validateAssetAllocationChange,
    onClick,
    isAllocationChangeable,
}: SelectionRowCompactProps) => {
    const [graphType] = useDiagramStore((state) => [state.graphType]);

    const [input, setInput] = useState(assetAllocation || '');
    const [isFocused, setIsFocused] = useState(false);

    useEffect(() => {
        setInput(assetAllocation || '');
    }, [assetAllocation]);

    const formatDisplayValue = (val: string | number) => {
        if (val === '' || val === null || val === undefined) return '';
        const numVal = typeof val === 'string' ? val : val.toString();
        if (isFocused && isAllocationChangeable) {
            return numVal;
        }
        return numVal + '%';
    };

    const stripPercent = (val: string) => {
        return val.replace(/%/g, '');
    };

    return (
        <SelectionLayoutRow
            isSecondary={true}
            onClick={onClick}
            type={type}
            showIcon={true}
            selectedCountry={country}
            // afterRow={<DeleteButton onClick={handleDelete} size={'sm'} />}
        >
            <div className={styles.inputWrapper}>
                <div className={`${inputStyles.inputField} ${styles.column}`}>
                    {/*// @ts-ignore*/}
                    {Countries[country?.toLowerCase()]?.domicileName}

                    {/*// @ts-ignore*/}
                    {/*<img width={30} src={Countries[country?.toLowerCase()]?.img} alt="" />*/}
                </div>
            </div>
            <div>
                <div className={`${inputStyles.inputField}`}>{value}</div>
            </div>
            <div className={styles.flex}>
                {/*<div className={`${styles.column} ${styles.sm}`}>*/}
                {/*{isAllocationChangeable ? (*/}
                {/*    <input*/}
                {/*        type="number"*/}
                {/*        step={2}*/}
                {/*        value={input}*/}
                {/*        onInput={(e: any) => {*/}
                {/*            console.log('value', e.target.value, e.target.value.replace(/[^\d]+/g, ''));*/}
                {/*            setInput(e.target.value.replace(/[^\d]+/g, ''));*/}
                {/*        }}*/}
                {/*        onBlur={() => validateAssetAllocationChange(+input)}*/}
                {/*    />*/}
                {/*) : (*/}
                {/*    assetAllocation*/}
                {/*)}*/}
                <Input
                    type={isFocused && isAllocationChangeable ? 'number' : 'text'}
                    value={formatDisplayValue(input)}
                    onFocus={() => {
                        setIsFocused(true);
                        setInput(stripPercent(input.toString()));
                    }}
                    onInput={(e: any) => {
                        const numericValue = e.target.value.replace(/[^\d]+/g, '');
                        // console.log('value', e.target.value, numericValue);
                        setInput(numericValue);
                    }}
                    onBlur={(e: any) => {
                        const numericValue = stripPercent(e.target.value);
                        setInput(numericValue);
                        setIsFocused(false);
                        validateAssetAllocationChange(+numericValue);
                    }}
                    note={'of AuM'}
                    readOnly={!isAllocationChangeable}
                    labelStyles={{
                        margin: 0,
                    }}
                    afterInput={<DeleteButton onClick={handleDelete} size={'sm'} />}
                    readOnlySecondary={true}
                />
            </div>
            {/*<span className={styles.note}>of AuM</span>*/}
            {/*</div>*/}
        </SelectionLayoutRow>
    );
};

export default SelectionRowCompact;
